import axiosClient, {AxiosRequestConfig} from 'axios'
import { TOKEN_SO_KEY } from '../../utils/accountUtils'
import { getSessionStorage } from '../../utils/StorageUtil'

export function toQueryString(values: any) {
  return Object.keys(values)
    .map((key) => key + '=' + values[key])
    .join('&')
}

export function getUrl(config: AxiosRequestConfig) {
  if (config?.baseURL) {
    return config.url?.replace(config.baseURL, '')
  }
  return config?.url
}

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT,PATCH',
  'Access-Control-Max-Age': '86400',
  'Access-Control-Allow-Headers':
    'Origin, X-Requested-With, Content-Type, Accept, x-auth-token, Authorization'
}

/**
 * Creates an initial 'axios' instance with custom settings.
 */
const AxiosInstance = axiosClient.create({
  baseURL: process.env.REACT_APP_GATEWAY_URL,
  headers: headers,
})

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = getSessionStorage(TOKEN_SO_KEY)
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

export const resetDefaults = () => {
  AxiosInstance.defaults.responseType = 'json'
}

export const CancelToken = axiosClient.CancelToken

/**
 * Replaces main `axios` instance with the custom-one.
 *
 * @param cfg - Axios configuration object.
 * @returns A promise object of a response of the HTTP request with the 'data' object already
 * destructured.
 const axios = <T>(cfg: AxiosRequestConfig) => instance.request<any, T>(cfg);
 */

export default AxiosInstance
